---
title: What Is Roddo?
description: A simple guide to Roddo, the fishing companion app for maps, catch logs, FishIQ signals, and community.
---

# What Is Roddo?

Roddo is a fishing companion app built around four simple jobs: find water, log catches, learn patterns, and share the day with other anglers.

It is not meant to replace local knowledge, regulations, weather alerts, or your judgment on the water. Roddo helps organize the information that can make fishing trips easier to plan and easier to learn from.

## What Roddo helps with

- **Big Blue:** explore nearby water and trip context.
- **Capt'n's Log:** save catches, photos, notes, gear, and conditions.
- **FishIQ:** read signals and guidance from patterns, not promises.
- **Baleen Bay:** share catches and moments with the community.

## The goal

Fishing has a lot of tiny details that are easy to forget. Roddo helps turn those details into a personal history you can actually use.

---

### Keep learning

- [Fishing map guide](/learn/fishing-map)
- [Catch log guide](/learn/catch-log)
- [FishIQ guide](/learn/fishiq)
